export const TopicLessonOrderDisplayType = {
    Published: 1,
    Unpublished: 2,
    // All: 3,
}
Object.freeze(TopicLessonOrderDisplayType)
